import { render, staticRenderFns } from "./PaymentChromeResult.vue?vue&type=template&id=66ca1cdb&scoped=true"
import script from "./PaymentChromeResult.vue?vue&type=script&lang=js"
export * from "./PaymentChromeResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ca1cdb",
  null
  
)

export default component.exports